import { get, post } from '../tools/http';
import { copy, comparer } from '../tools/comparer';
import { isoStringToYYYYMMDD } from '../tools/moment-date';
import { parseISO, endOfMonth, format } from 'date-fns';

export default {
    state: {
        careers: [],
        careersServer: [],
    },
    mutations: {
        setCareers: (state, careers) => {
            state.careers = careers;
            state.careersServer = copy(careers);
        },
        setCareer: (state, Careers) => {
            state.careers.push(Careers);
            state.careersServer.push(copy(Careers));
        },
        updateCareer: (state, career) => {
            let careerFinderIndex = state.careers.findIndex((car) => {
                return car.id == career.id;
            });
            if (careerFinderIndex > -1) {
                state.careers[careerFinderIndex] = {
                    ...state.careers[careerFinderIndex],
                    ...career,
                };
                state.careersServer[careerFinderIndex] = {
                    ...state.careersServer[careerFinderIndex],
                    ...copy(career),
                };
            }
        },
        removeCareer: (state, index) => {
            state.careers.splice(index, 1);
            state.careersServer.splice(index, 1);
        },
    },
    actions: {
        loadCareers: async (ctx) => {
            let careers = await get('profile', 'career');
            ctx.commit('setCareers', careers.career.map((edu)=>{
                    return {
                        ...edu,
                        dateStart: isoStringToYYYYMMDD(edu['dateStart']),
                        dateEnd: isoStringToYYYYMMDD(edu['dateEnd']),
                    };
            }));
        },
        addCareers: async (ctx) => {
            const newCareer = {
                "position": "",
                "organisation" : "",
                "dateStart": null,
                "dateEnd": null,
                "region": null,
                "website": "",
                "foreignPositionLevelId": null,
                "foreignWorkersNumberId": null,
                "isUntilNow": false,
                "responsibilities": "",
            };
            const postParams = [
                'profile',
                'career/create',
                newCareer,
                true,
            ];
            let newCareerId = await post(...postParams);
            ctx.commit('setCareer', {
                ...newCareer,
                id: newCareerId.id,
            });
        },
        updateCareer: async (ctx, {car, index}) => {
            const prevCareer = ctx.state.careersServer[index];

            if (!car.isUntilNow && car.dateEnd) {
                const dateEnd = parseISO(car.dateEnd);
                car.dateEnd = format(endOfMonth(dateEnd), 'yyyy-MM-dd');
            }

            const diff = comparer(prevCareer, car);
            if (Object.keys(diff).length > 0) {
                const postParams = [
                    'profile',
                    'career/update',
                    {...diff, id: car.id},
                    true,
                ];
                await post(...postParams);
                ctx.commit('updateCareer', {...diff, id: prevCareer.id});
            }
        },
        removeCareer: async (ctx, {career, index}) => {
            if (career.id) {
                const getParams = [
                    'profile',
                    `career/${career.id}/remove`,
                ];
                await get(...getParams);
            }
            ctx.commit('removeCareer', index);
        },
    },
    getters: {
        getCareers: state => state.careers,
    },
};